<template>
  <div>
    <!-- Subtitulo -->
    <div
      v-if="title"
      class="col-md-12">
      <h4 class="title-manage-account">{{ title }}</h4>
    </div>
    <div class="col-md-12 padding-off">
      <div class="col-md-4">
        <!-- CEP -->
        <input-field
          :submitted="submitted"
          :field.sync="form.zip_code"
          :required="true"
          :mask="['#####-###']"
          label="CEP"
          type="text"
          name="zip_code"
          validate="required"></input-field>
        <!-- / CEP -->
      </div>
      <div class="col-md-8">
        <!-- Endereço -->
        <input-field
          :submitted="submitted"
          :field.sync="form.street"
          :required="true"
          label="Endereço"
          type="text"
          name="street"
          validate="required"></input-field>
        <!-- / Endereço -->
      </div>
    </div>
    <div class="col-md-12 padding-off">
      <!-- Número -->
      <div class="col-md-4">
        <!-- Número -->
        <input-field
          :submitted="submitted"
          :field.sync="form.number"
          :required="true"
          label="Número"
          type="number"
          name="number"
          validate="required"></input-field>
        <!-- / Número -->
      </div>
      <div class="col-md-8">
        <!-- Complemento -->
        <input-field
          :field.sync="form.complement"
          label="Complemento"
          type="text"
          name="complement"></input-field>
        <!-- / Complemento -->
      </div>
    </div>
    <div class="col-md-12 padding-off">
      <div class="col-md-6">
        <!-- Bairro -->
        <input-field
          :submitted="submitted"
          :field.sync="form.neighborhood"
          :required="true"
          label="Bairro"
          type="text"
          name="neighborhood"
          validate="required"></input-field>
        <!-- / Bairro -->
      </div>
      <div class="col-md-6">
        <!-- Cidade -->
        <input-field
          :submitted="submitted"
          :field.sync="form.city"
          :required="true"
          label="Cidade"
          type="text"
          name="city"
          validate="required"></input-field>
        <!-- / Cidade -->
      </div>
    </div>
    <div class="col-md-12 padding-off">
      <div class="col-md-6">
        <!-- Estado -->
        <input-field
          :submitted="submitted"
          :field.sync="form.province"
          :required="true"
          label="Estado"
          type="text"
          name="province"
          validate="required"></input-field>
        <!-- / Estado -->
      </div>
      <div class="col-md-6">
        <!-- País -->
        <select-countries
          v-if="form.hasOwnProperty('country')"
          :submitted="submitted"
          :field.sync="form.country"
          :required="true"
          validate="required"
          name="country"></select-countries>
        <select-countries
          v-if="form.hasOwnProperty('country_id')"
          :submitted="submitted"
          :field.sync="form.country_id"
          :required="true"
          validate="required"
          name="country_id"></select-countries>
        <!-- / País -->
      </div>
    </div>
  </div>
</template>

<script>
import InputField from '@/components/fields/InputField'
import SelectCountries from '@/components/fields/SelectCountries'

export default {
  inject: [ '$validator' ],
  components: {
    InputField,
    SelectCountries
  },
  props: [
    'title',
    'submitted',
    'form'
  ]
}
</script>
